import { Box, CircularProgress, Typography } from "@mui/material";
import { useSingleOrgDashboard } from "../../../../context/SuperAdmin/DashboardContexts/SingleOrg";
import SingleEntityBarChart from "./SingleEntityBarChart";
import SingleEntityInfoBoxes from "./SingleEntityInfoBoxes";
import {
  CreditosOrganizacion,
  CreditosSuborganizacion,
  CreditosSuscripcion,
  CreditosUsario,
} from "../../../../interfaces/SuperAdmin/Pages/iDataCreditos";
import { FC } from "react";

interface Props {
  credits:
    | CreditosOrganizacion
    | CreditosSuborganizacion
    | CreditosUsario
    | CreditosSuscripcion;
  isLoading: boolean;
}

const SingleTotalCreditos: FC<Props> = ({ credits, isLoading }) => {
  if (isLoading) {
    return (
      <Box
        sx={{
          height: "300px",
          width: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box display="flex" flexDirection="column" alignItems="center">
          <CircularProgress />
          <Typography
            variant="body2"
            mt={2}
            fontFamily={"Montserrat"}
            fontSize={16}
          >
            Cargando créditos totales...
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <>
      <SingleEntityInfoBoxes credits={credits} />
      <SingleEntityBarChart credits={credits} />
    </>
  );
};

export default SingleTotalCreditos;
